// extracted by mini-css-extract-plugin
export var cardHeader = "_e5-0";
export var reorderHandle = "_e5-3";
export var titleArea = "_e5-1";
export var titleAreaWithHandle = "_e5-2";